import {useCallback, useEffect, useMemo, useRef, useState} from 'react';

import {Assertion, AssertionStore} from '@udemy/badging';

import {useBadgeAssertionQuery} from '../generated/graphql';

export function useAssertion(assertionId: string) {
    const [assertion, setAssertion] = useState<Assertion>();
    const [loading, setLoading] = useState(true);
    const isMounted = useRef(true);
    const assertionStore = useMemo(() => new AssertionStore(), []);

    const loadAssertion = useCallback(async () => {
        let assertion;
        try {
            const resp = await useBadgeAssertionQuery.fetcher({id: assertionId})();
            assertionStore.setAssertion(resp.badgeAssertion as Assertion);
            assertion = assertionStore.assertion;
        } catch (e) {
            assertion = undefined;
        }

        if (isMounted.current) {
            setAssertion(assertion);
            setLoading(false);
        }
    }, [assertionId, assertionStore]);

    useEffect(() => {
        isMounted.current = true;

        loadAssertion();

        return () => {
            isMounted.current = false; // Set to false when the component unmount
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps -- only run once

    return {assertion, assertionStore, loading};
}
